export default "__VITE_ASSET__BYjufqB6__"